export default __webpack_public_path__ + "static/media/error.ec6898f9.svg";